import { createStore, combineReducers, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import createHistory from "history/createBrowserHistory";
import { routerReducer, routerMiddleware } from "react-router-redux";
import { HeaderState } from "./header/types";
import header from "./header/reducer";
import cases from "./cases/reducer";
import facebook from "./facebook/reducer";

import { CaseState } from "./cases/types";
import { FacebookState } from "./facebook/types";

// Create a history of your choosing (we're using a browser history in this case)
export const PATH_BASENAME = "/";
export const history = createHistory({ basename: PATH_BASENAME });

// Build the middleware for intercepting and dispatching navigation actions
const historyMiddleware = routerMiddleware(history);

export interface GlobalState {
  header: HeaderState;
  cases: CaseState;
  facebook: FacebookState;
}

const appReducer = combineReducers<GlobalState>({
  routerReducer,
  header,
  cases,
  facebook
});
const store = createStore<GlobalState>(
  appReducer,
  applyMiddleware(thunkMiddleware, historyMiddleware)
);
export default store;



// WEBPACK FOOTER //
// ./src/store/index.ts